import { timeline } from "@/mocks/timeline";
import SectionHeading from "./SectionHeading";

export default function TimelineSection() {
  return (
    <section id="timeline" className="w-full bg-secondary-950 px-4 md:px-8 py-14 md:py-20">
      <div className="w-full">
        <div className="grid grid-cols-1 lg:grid-cols-[380px_1fr] gap-10 lg:gap-14">
          <div className="lg:sticky lg:top-24 self-start">
            <span className="inline-flex items-center gap-1.5 text-xs md:text-sm font-medium tracking-widest text-accent-400 mb-3">
              <i className="ri-subtract-line" />
              大瓜合集时间线
            </span>
            <h2 className="font-heading font-bold text-background-50 text-2xl md:text-3xl lg:text-4xl leading-snug mb-4">
              一个瓜，六步看完
            </h2>
            <p className="text-sm md:text-base text-background-200/85 leading-relaxed mb-6">
              以「春日档古装剧番位风波」为样本，我们把两周的讨论拆成六个关键节点。看完你会发现，风向往往不是在某一次争吵里改变的，而是在某一次正式回应之后。
            </p>
            <div className="grid grid-cols-2 gap-3">
              <div className="rounded-lg bg-secondary-900/70 border border-secondary-800 p-4">
                <p className="font-heading font-bold text-2xl text-accent-400">14 天</p>
                <p className="text-xs text-background-300/85 mt-1">事件完整周期</p>
              </div>
              <div className="rounded-lg bg-secondary-900/70 border border-secondary-800 p-4">
                <p className="font-heading font-bold text-2xl text-accent-400">6 个</p>
                <p className="text-xs text-background-300/85 mt-1">关键转折节点</p>
              </div>
            </div>
          </div>

          <ol className="relative">
            <span className="absolute left-[13px] top-2 bottom-2 w-px bg-secondary-800" aria-hidden="true" />
            {timeline.map((node, index) => (
              <li key={node.date} className="relative pl-10 pb-8 last:pb-0">
                <span
                  className={`absolute left-0 top-0.5 w-7 h-7 flex items-center justify-center rounded-full text-[11px] font-medium ${
                    index === 0
                      ? "bg-accent-500 text-foreground-950"
                      : "bg-secondary-800 text-background-200 border border-secondary-700"
                  }`}
                >
                  {index + 1}
                </span>
                <div className="rounded-lg bg-secondary-900/60 border border-secondary-800 p-4 md:p-5 hover:border-accent-500/50 transition-colors">
                  <div className="flex flex-wrap items-center gap-2.5 mb-2">
                    <span className="font-heading font-bold text-accent-400 text-sm">{node.date}</span>
                    <span className="px-2 py-0.5 rounded-full bg-secondary-800 text-[11px] text-background-200">
                      {node.stage}
                    </span>
                  </div>
                  <h3 className="font-heading font-bold text-background-50 text-base md:text-lg leading-snug mb-2">
                    {node.title}
                  </h3>
                  <p className="text-sm text-background-200/80 leading-relaxed">{node.desc}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}